
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 14.5A1.5 1.5 0 014 13h16a1.5 1.5 0 010 3H4a1.5 1.5 0 01-1.5-1.5zM3 18.5a1 1 0 011-1h16a1 1 0 011 1 2.5 2.5 0 01-2.5 2.5h-13A2.5 2.5 0 013 18.5zM3 7.286A4.286 4.286 0 017.286 3h9.428A4.286 4.286 0 0121 7.286c0 .394-.32.714-.714.714H3.714A.714.714 0 013 7.286zM8.25 11.75l-.057-.057a1.848 1.848 0 00-2.49-.113l-.461.385a1.5 1.5 0 01-2.181-.28l-.432-.604A1 1 0 013.443 9.5h17.114a1 1 0 01.814 1.581l-.432.604a1.5 1.5 0 01-2.18.28l-.463-.385a1.848 1.848 0 00-2.49.113l-.056.057c-.69.69-1.81.69-2.5 0s-1.81-.69-2.5 0-1.81.69-2.5 0z"}})])
          )
        }
      }
    